import { call, put } from 'redux-saga/effects'
import api from './../../utils/api'
import actions from './actions'

const queryPermissions = () => call(api.getPermissions)

function* fetchPermissions() {
  let permissions
  try {
    permissions = yield queryPermissions()
  } finally {
    yield put({ type: actions.setPermissions, permissions })
  }
}

export default fetchPermissions



// WEBPACK FOOTER //
// ./src/store/permissions/saga.js